import { RouterLayoutProps } from "@opendash/router";
import * as React from "react";
import { RouterLayoutBasic } from "..";

export const RouterLayoutBasicPadding = React.memo<RouterLayoutProps>(
  function RouterLayoutBasicPadding({ children, ctx }) {
    return <RouterLayoutBasic children={children} ctx={ctx} padding />;
  }
);
